import FinancingType from '~/constants/FinancingType';
import { CreditStatus } from '~/contracts';

export function getFinancingType(creditStatus: CreditStatus) {
  return creditStatus.hasExpiredSoftPull
    ? FinancingType.Expired
    : creditStatus.hasValidSoftPull
    ? FinancingType.UserFinancing
    : FinancingType.EstimatedFinancing;
}
